module.exports = (__webpack_require__("bricks/next-builder:bbjC"))("2TRZ");